// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

import FileControls from '@/components/files/handler/viewer/controls/FileControls.vue';
import FileControlsButton from '@/components/files/handler/viewer/controls/FileControlsButton.vue';
import FileControlsDropdown from '@/components/files/handler/viewer/controls/FileControlsDropdown.vue';
import FileControlsDropdownItem from '@/components/files/handler/viewer/controls/FileControlsDropdownItem.vue';
import FileControlsDropdownPopover from '@/components/files/handler/viewer/controls/FileControlsDropdownPopover.vue';
import FileControlsFlux from '@/components/files/handler/viewer/controls/FileControlsFlux.vue';
import FileControlsGroup from '@/components/files/handler/viewer/controls/FileControlsGroup.vue';
import FileControlsInput from '@/components/files/handler/viewer/controls/FileControlsInput.vue';
import FileControlsPagination from '@/components/files/handler/viewer/controls/FileControlsPagination.vue';
import FileControlsPlayback from '@/components/files/handler/viewer/controls/FileControlsPlayback.vue';
import FileControlsVolume from '@/components/files/handler/viewer/controls/FileControlsVolume.vue';
import FileControlsZoom from '@/components/files/handler/viewer/controls/FileControlsZoom.vue';
import FileViewerBackground from '@/components/files/handler/viewer/FileViewerBackground.vue';

export {
  FileControls,
  FileControlsButton,
  FileControlsDropdown,
  FileControlsDropdownItem,
  FileControlsDropdownPopover,
  FileControlsFlux,
  FileControlsGroup,
  FileControlsInput,
  FileControlsPagination,
  FileControlsPlayback,
  FileControlsVolume,
  FileControlsZoom,
  FileViewerBackground,
};

export type { FileControlsDropdownItemContent } from '@/components/files/handler/viewer/types';
